// What every mutations file builds its writes with: roles and the create / update / remove / custom shapes, used by
// shared/mutations.ts and each area's shared/mutations-*.ts. A module of its own, so the area files needn't import
// mutations.ts (which imports them).
import { z } from "zod";
import type { SyncedTables } from "./db.gen.ts";

export const ROLES = ["admin", "inventory", "receiving"] as const;
export type Role = (typeof ROLES)[number];
export type TableName = keyof SyncedTables & string;

export const STAFF = ["admin", "inventory"] as const;
export const ADMIN = ["admin"] as const;

// The helpers take the field shape (not a generic ZodObject) so TypeScript keeps every field's type.
export const create = <T extends TableName, S extends z.core.$ZodShape>(table: T, fields: z.ZodObject<S>, roles: readonly Role[] = STAFF) => ({
  kind: "create" as const,
  table,
  roles,
  args: z.object({ ...fields.shape, id: z.uuid() }),
});

export const update = <T extends TableName, S extends z.core.$ZodShape>(table: T, fields: z.ZodObject<S>, roles: readonly Role[] = STAFF) => ({
  kind: "update" as const,
  table,
  roles,
  args: z.object({ id: z.uuid(), patch: fields.partial() }),
});

export const remove = <T extends TableName>(table: T, roles: readonly Role[] = STAFF) => ({
  kind: "remove" as const,
  table,
  roles,
  args: z.object({ id: z.uuid() }),
});

export const custom = <S extends z.ZodType>(args: S, roles: readonly Role[] = STAFF) => ({ kind: "custom" as const, table: null, roles, args });
